<template>
  <div class="dynamic-calculator container" :class="{ active: disableButton }">
    <div class="flex dynamic-calculator__main-heading">
      <div class="mark bg-light-purple">%</div>
      <h2 class="f-24">{{ _.get(data, "header.title") }}</h2>
    </div>

    <div class="dynamic-content">
      <p class="dynamic-content__text f-16">
        {{ $fn.tr("გამოთვალე დაზღვევის დაახლოებითი ღირებულება") }}
      </p>
      <el-form
        :model="ruleFormItems"
        :rules="rules"
        ref="ruleForm"
        class="dynamic-calculator__form"
      >
        <!-- :rules="{
            re    color: #7063e9;
    font-size: 55px;
    line-height: normal;quired: true,
            message: 'domain can not be null',
            trigger: 'blur'
          }" -->

        <!-- :prop="'inputs.' + index + '.value'" -->
        <div class="row">
          <div class="input-grid">
            <template v-for="(inputValue, index) in dynamicInputs">
              <el-form-item
                v-if="hideInputs !== inputValue.name"
                :key="index"
                :prop="inputValue.name"
              >
                <el-select
                  v-model="ruleFormItems[inputValue.name]"
                  :placeholder="inputValue.title"
                  v-if="inputValue.type == 'select'"
                  :popper-append-to-body="false"
                  @visible-change="
                    $store.commit('main/setState', {
                      key: 'stop_scroll',
                      val: !stop_scroll
                    })
                  "
                >
                  <el-option
                    v-for="(option, index2) in Object.keys(inputValue.options)"
                    :key="index2"
                    :label="inputValue.options[option]"
                    :value="option"
                  >
                  </el-option>
                </el-select>
                <!-- <el-input
                  v-if="
                    inputValue.type != 'select' && inputValue.type != 'radio'
                  "
                  :type="inputValue.type"
                  v-model="ruleFormItems[inputValue.name]"
                  :placeholder="inputValue.title"
                ></el-input> -->
                <div
                  v-if="
                    inputValue.type != 'select' &&
                      inputValue.type != 'radio' &&
                      inputValue.type != 'checkbox' &&
                      inputValue.type != 'calendar'
                  "
                  class="input-wrapper rel"
                >
                  <el-input
                    :type="inputValue.type"
                    @focus="focused = true"
                    @blur="focused = false"
                    v-model="ruleFormItems[inputValue.name]"
                  ></el-input>
                  <label
                    :class="
                      focused
                        ? 'focused'
                        : ruleFormItems[inputValue.name]
                        ? 'focused'
                        : ''
                    "
                    class="p-2 c-secondary regular ev-none"
                  >
                    {{ inputValue.title }}
                  </label>
                </div>

                <el-date-picker
                  v-if="
                    inputValue.type == 'calendar' &&
                      _.includes(_.get(inputValue, 'confs'), 'additionalData')
                  "
                  v-model="calendar"
                  type="daterange"
                  range-separator=""
                  :start-placeholder="$fn.tr('დაწყება')"
                  :end-placeholder="$fn.tr('დასრულება')"
                  value-format="yyyy-MM-dd"
                  class="calculator-date-picker"
                >
                </el-date-picker>
                <el-date-picker
                  v-if="
                    inputValue.type == 'calendar' &&
                      !_.includes(_.get(inputValue, 'confs'), 'additionalData')
                  "
                  v-model="ruleFormItems[inputValue.name]"
                  :placeholder="inputValue.title"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
                <div class="radio" v-if="inputValue.type == 'radio'">
                  <span
                    v-if="inputValue.title"
                    class="medium f-16 complaint_modal__radio_label"
                    >{{ inputValue.title }}</span
                  >
                  {{ ruleFormItems[inputValue.name] }}
                  <el-radio-group v-model="ruleFormItems[inputValue.name]">
                    <el-radio
                      v-for="(option, index3) in Object.keys(
                        inputValue.options
                      )"
                      :key="index3"
                      :label="option"
                    >
                      {{ inputValue.options[option] }}
                    </el-radio>
                  </el-radio-group>
                </div>
                <div
                  class="checkbox"
                  v-if="
                    inputValue.type == 'checkbox' &&
                      inputValue.title !== 'addones'
                  "
                >
                  <span
                    v-if="
                      inputValue.title &&
                        !_.includes(_.get(inputValue, 'confs'), 'hidden')
                    "
                    class="medium f-16 complaint_modal__radio_label"
                    >{{ inputValue.title }}
                  </span>

                  <el-checkbox
                    v-for="(option, indx) in Object.keys(inputValue.options)"
                    :key="indx"
                    :value="option"
                    v-model="ruleFormItems[inputValue.name]"
                    :label="inputValue.options[option]"
                  >
                  </el-checkbox>
                </div>
                <div
                  class="checkbox"
                  v-if="
                    inputValue.type == 'checkbox' &&
                      inputValue.title == 'addones'
                  "
                >
                  <span
                    v-if="
                      inputValue.title &&
                        !_.includes(_.get(inputValue, 'confs'), 'hidden') &&
                        inputValue.title !== 'addones'
                    "
                    class="medium f-16 complaint_modal__radio_label"
                    >{{ inputValue.title }}
                  </span>
                  <el-checkbox-group v-model="ruleFormItems[inputValue.name]">
                    <el-checkbox
                      v-for="(option, indx) in Object.keys(inputValue.options)"
                      :key="indx"
                      :value="option"
                      :label="option"
                    >
                      {{ inputValue.options[option] }}
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </el-form-item>
            </template>
          </div>
          <div v-if="errMessage" class="error-message">
            {{ errMessage }}
          </div>
        </div>

        <el-button
          class="dynamic-calculator__validate-button button"
          @click="submitForm('ruleForm')"
        >
          <span class="f-16 uppercase">{{ $fn.tr("გამოთვალე") }}</span>
        </el-button>
      </el-form>

      <slide-up-down :active="slideAnimation" :duration="1000">
        <div class="flex request-info-content">
          <div class="request-info-content__details">
            <div class="details-list">
              <template v-for="(item, indx) in dynamicInputs">
                <p v-if="item.type == 'select'" class="f-14 bold" :key="indx">
                  {{ item.title }} :
                  <span>{{ item.options[ruleFormItems[item.name]] }} </span>
                </p>
                <!-- for property result data -->
                <p
                  v-if="
                    (data.formType == 'property' &&
                      item.title &&
                      item.type == 'checkbox' &&
                      ruleFormItems[item.name]) ||
                      (data.formType == 'property' && item.type == 'number')
                  "
                  class="f-14 bold"
                  :key="indx"
                >
                  {{ item.title }} :
                  <span>
                    {{
                      item.type == "number"
                        ? ruleFormItems[item.name]
                        : item.options["1"]
                    }}</span
                  >
                </p>
              </template>
            </div>

            <p class="f-13 static-text">
              {{ $fn.tr("calculator_info_text") }}
            </p>
          </div>
          <div class="request-info-content__actions">
            <p class="f-16 bold">
              {{ $fn.tr(data.priceTitle) || $fn.tr("ყოველთვიური გადასახადი") }}:
            </p>
            <h3 class="price bold">
              ₾
              {{
                _.get(responseData, "price") ||
                  _.get(responseData, "frequencyPremium")
              }}
            </h3>

            <div class="action-buttons">
              <div class="flex">
                <button
                  @click="openModal"
                  class="button bg-light-purple  pointer"
                  type="button"
                >
                  <svg
                    id="Group_5_Copy_3"
                    data-name="Group 5 Copy 3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.352"
                    height="11.351"
                    viewBox="0 0 11.352 11.351"
                  >
                    <path
                      id="Combined_Shape_Copy_2"
                      data-name="Combined Shape Copy 2"
                      d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                      fill="#fff"
                    />
                  </svg>

                  {{ $fn.tr("ყიდვა") }}
                </button>
                <a
                  :href="_.get(data, 'header.full_list_url')"
                  target="_blank"
                  class="font-14 bold"
                >
                  <svg
                    id="Group_5_Copy_3"
                    data-name="Group 5 Copy 3"
                    xmlns="http://www.w3.org/2000/svg"
                    width="11.352"
                    height="11.351"
                    viewBox="0 0 11.352 11.351"
                  >
                    <path
                      id="Combined_Shape_Copy_2"
                      data-name="Combined Shape Copy 2"
                      d="M5.007,11.074a.946.946,0,0,1,0-1.338L8.122,6.622H.946a.946.946,0,0,1,0-1.892H8.121L5.007,1.615A.946.946,0,1,1,6.344.277l4.73,4.729.016.017.008.009.008.008.01.011.006.006.011.012,0,0,.011.014,0,0,.011.014,0,0,.011.015,0,0,.01.015,0,0,.009.014,0,.005.008.013,0,.007.007.011.006.01,0,.009.007.013,0,.006.009.017v0a.946.946,0,0,1-.194,1.1L6.344,11.074a.946.946,0,0,1-1.338,0Z"
                      fill="#7063e9"
                    />
                  </svg>
                  {{ _.get(data, "header.full_list_title") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </slide-up-down>
    </div>
  </div>
</template>
<script>
import fn from "@/helpers/func";

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ruleForm: {
        age: null,
        packet: null,
        limit: null,
        inputs: []
      },
      rules: {},
      dynamicValidateForm: {
        domains: [
          {
            key: 1,
            value: ""
          }
        ],
        email: ""
      },
      slideAnimation: false,

      dynamicInputs: [],
      clonedDynamicInputs: [],

      ruleFormItems: {},

      hideInputs: {},
      focused: false,
      disableButton: false,
      calendar: "",
      dependency: { dependencyKey: "", dependencyValue: "" },
      responseData: null,
      errMessage: ""
    };
  },

  computed: {
    stop_scroll() {
      return this.$store.state.main.stop_scroll;
    },
    getCalculatorConfigs() {
      return _.find(
        _.get(this.$store.state.main, "smartForms"),
        item => item?.form_name == _.get(this.data, "formType")
      );
      // return _.get(this.$store.state.main, "smartForms")?.find(
      //   item => item?.form_name == _.get(this.data, "formType")
      // );
    },
    watchDependency() {
      return this.ruleFormItems[this.dependency.dependencyKey];
    }
  },
  watch: {
    getCalculatorConfigs: {
      immediate: true,
      handler(val) {
        this.dynamicInputs = [];
        if (val)
          val.form_config.forEach(value => {
            this.dynamicInputs.push({
              options: {
                ...value.values
              },
              title: value.title[this.$store.state.main.locale],
              type: value.type,
              name: value.name,
              dependency: value.dependency,
              confs: value.confs,
              model: ""
            });
            let obj = {};
            obj[value.name] =
              value.type == "checkbox" &&
              value.title[this.$store.state.main.locale] == "addones"
                ? []
                : value.type == "checkbox"
                ? false
                : "";
            this.ruleFormItems = { ...Object.assign(this.ruleFormItems, obj) };

            if (value.validate?.required?.status) {
              const requiredRule = {
                message: value.validate?.required?.status
                  ? value.validate?.required?.msg[this.$store.state.main.locale]
                  : "",
                required: value.validate?.required?.status,
                trigger: value.validate?.required?.status
                  ? ["blur", "change"]
                  : []
              };
              this.rules[value.name] = requiredRule;
              this.rules = Object.assign(this.rules, requiredRule);
            }
            // else this.rules[value.name] = value.validate;
          });
      }
    },
    ruleFormItems: {
      deep: true,
      handler(val) {
        this.disableButton = false;
        this.slideAnimation = false;
        let dependency = {};
        // const tt = [];

        this.dynamicInputs.forEach(item => {
          if (val[item.name] && item.dependency) {
            dependency = item.dependency.find(dp => {
              return dp.value == val[item.name];
            });
            this.dependency.dependencyValue = dependency;
            this.dependency.dependencyKey = item.name;
          }
        });

        const index = this.dynamicInputs.findIndex(object => {
          return object.name === _.get(dependency, "field[0]");
        });
        if (index >= 0) {
          const filteredOptions = _.flow([
            Object.entries,
            arr =>
              arr.filter(
                ([key, value]) =>
                  !_.get(
                    dependency,
                    `fieldValues[${_.get(dependency, "field[0]")}]`
                  ).includes(value)
              ),
            Object.fromEntries
          ])(this.clonedDynamicInputs[index].options);

          this.dynamicInputs[index].options = filteredOptions;
        }
      }
    },
    watchDependency: {
      deep: true,
      handler() {
        this.ruleFormItems[_.get(this.dependency.dependencyValue, "field[0]")] =
          "";
      }
    },
    calendar(val) {
      this.ruleFormItems["PolicyFromDate-PolicyToDate"] = val;
    }
  },
  methods: {
    async submit_form() {
      console.log(this.dynamicInputs, "dynamicInputs");
      if (this.disableButton) {
        return;
      }
      this.disableButton = true;

      let customRuleFromItems = JSON.parse(JSON.stringify(this.ruleFormItems));
      if (this.ruleFormItems.hasOwnProperty("PolicyFromDate-PolicyToDate")) {
        customRuleFromItems["PolicyFromDate"] = this.calendar[0];
        customRuleFromItems["PolicyToDate"] = this.calendar[1];
        delete customRuleFromItems["PolicyFromDate-PolicyToDate"];
      }
      if (this.ruleFormItems.hasOwnProperty("addones")) {
        customRuleFromItems["addones"] = this.ruleFormItems[
          "addones"
        ].map(item => parseInt(item));
      }
      this.dynamicInputs.forEach(item => {
        if (item.confs.includes("customCheckbox")) {
          customRuleFromItems[item.name] = this.ruleFormItems[item.name]
            ? 1
            : 0;
        }
        // if (item.confs.includes("customNumber")) {
        //   this.ruleFormItems[item.name] = parseInt(
        //     this.ruleFormItems[item.name]
        //   );
        // }
      });
      console.log(this.ruleFormItems, "ruleFormItemsruleFormItems");
      let clonedResultItems = {
        ...customRuleFromItems
      };
      // for (let i in clonedResultItems) {
      //   clonedResultItems[i] = parseInt(clonedResultItems[i]);
      // }

      let res = await fn.postData(
        `main/serviceCaller?callerId=TbcInsuranceCalculators_${_.get(
          this.data,
          "axiosLink"
        )}`,
        clonedResultItems
      );
      this.errMessage = "";

      if (res.data.status != 0) {
        this.errMessage =
          res.data.description ||
          res.data.DescriptionGeo ||
          res.data.Description ||
          res.data.message;
        this.disableButton = false;
        this.slideAnimation = false;
        return;
      }
      this.errMessage = "";
      this.responseData =
        this.data.formType == "life"
          ? { price: res.data?.totalPremium }
          : this.data.formType == "travel"
          ? { price: res.data?.premium / 100 }
          : res.data;
      if (this.data.formType == "automini") {
        this.responseData = { price: res.data?.cascoCalculation?.totalPremium };
      }
      this.success_sent = true;
      this.slideAnimation = true;
      this.disableButton = true;
    },
    submitForm(formName) {
      this.$refs[formName]?.validate(valid => {
        if (valid) {
          this.submit_form();
        } else {
          console.log("error submit!!");

          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName]?.resetFields();
    },
    openModal() {
      this.$store.commit("main/setState", {
        key: "lead_modal",
        val: true
      });
      this.$store.commit("main/setState", {
        key: "lead_modal_type",
        val: { type: this.data.formType, formValues: this.ruleFormItems }
      });
    }
  },
  mounted() {
    if (this.dynamicInputs.length) {
      this.clonedDynamicInputs = JSON.parse(JSON.stringify(this.dynamicInputs));
    }
  }
};
</script>
<style lang="scss">
.dynamic-calculator {
  padding-top: 89px;
  padding-bottom: 89px;
  .bg-grey {
    background-color: #f4f6f8;
  }
  .error-message {
    color: #f56c6c;
    font-size: 12px;
  }
  &__main-heading {
    align-items: center;
    margin-bottom: 25px;
    .mark {
      width: 40px;
      height: 40px;
      min-width: 40px;
      color: #fff;
      display: flex;
      margin-right: 20px;
      align-items: center;
      border-radius: 100px;
      justify-content: center;
    }
  }
  &.active {
    .dynamic-calculator__validate-button {
      color: #b5b5b6;
      border-color: #b5b5b6;
      cursor: not-allowed;
      &:hover {
        color: #b5b5b6;
        background-color: transparent;
      }
    }
  }
  .details-list {
    p {
      color: #575757;
    }
  }
  .action-buttons {
    margin-top: auto;
    .flex {
      align-items: center;
    }
    button {
      position: relative;
      background-color: #7063e9;
      color: white;
      font-family: "TBCSailec-Bold";
      transition: 0.4s;
      cursor: pointer;
      height: 60px;
      display: flex;
      justify-content: center;
      align-items: center;
      width: fit-content;
      border-radius: 6px;
      text-transform: uppercase;
      font-feature-settings: "case" on;
      font-size: 14px;
      svg {
        path {
          fill: #ffffff;
        }
      }
      &:hover {
        background-color: #613dd1;
      }
    }
    a {
      margin-left: 37px;
      color: #7063e9;
    }
  }
  .radio-form-item {
    margin-bottom: 0;
    .radio {
      display: flex;
      .complaint_modal__radio_label {
        margin-right: 20px;
      }
      .el-radio-group {
        display: flex;
      }
    }
  }
  .input-wrapper {
    label {
      position: absolute;
      top: 0;
      left: 16px;
      transition: 0.2s ease;
      transform: translateY(13px);
      z-index: 2;
      pointer-events: none;
      &.focused {
        transform: translate(-9%, 2px) scale(0.84);
      }
      @media (max-width: 767px) {
        transform: translateY(15px);
        &.focused {
          transform: translate(-9%, 7px) scale(0.84);
        }
      }
    }
    input {
      position: relative;
      padding-top: 10px;
      @media (max-width: 767px) {
        padding-top: 15px;
      }
    }
  }
  .el-radio__input.is-checked .el-radio__inner {
    background-color: transparent;
    border: 1px solid #7063e9;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #7063e9;
    border: 1px solid #7063e9;
  }
  .el-radio__inner::after {
    width: 10px;
    height: 10px;
    border-radius: 100%;
    background-color: #7063e9;
  }
  .el-radio__input.is-checked + .el-radio__label,
  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #606266;
  }
}
.dynamic-content {
  border-radius: 12px;
  padding: 20px 30px 50px;
  background-color: #f4f6f8;
  &__text {
    color: #6d6e70;
    margin-bottom: 30px;
  }
  .dynamic-calculator {
    &__form {
      display: flex;
      justify-content: space-between;
      .el-select {
        width: 100%;
        margin-right: 30px;
        .el-input {
          &__inner {
            &::placeholder {
              color: #000;
            }
            &:focus {
              border-color: #7063e9;
            }
          }
        }
      }

      .el-select-dropdown {
        &__item {
          &.selected {
            color: #7063e9;
          }
        }
        &__wrap {
          max-height: 140px;
        }
      }

      .small-select {
        max-width: 200px;
        min-width: 200px;
      }
      .el-input {
        &__inner {
          height: 50px;
        }
      }
      .el-button {
        height: 50px;
        background-color: transparent;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    &__validate-button {
      color: #7063e9;
      border-color: #7063e9;
      transition: 0.3s ease-in-out;
      &:hover {
        color: #fff;
        background-color: #7063e9;
      }
    }
  }
  .request-info-content {
    padding-top: 50px;
    justify-content: space-between;
    @media (max-width: 1023px) {
      flex-direction: column;
    }
    &__details {
      width: calc(50% - 15px);
      .static-text {
        color: #6d6e70;
        padding-top: 35px;
      }
      @media (max-width: 1023px) {
        width: 100%;
      }
    }
    &__actions {
      width: calc(50% - 15px);
      display: flex;
      flex-direction: column;
      @media (max-width: 1023px) {
        margin-top: 55px;
        width: 100%;
      }
      .price {
        font-size: 55px;
        color: #7063e9;
        line-height: normal;
        margin-top: 16px;
      }
      p {
        color: #575757;
      }
    }
  }
}
@media (max-width: 767px) {
  .el-date-range-picker .el-picker-panel__body {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
</style>
